"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveLeaderboardGalleryItem } from "./WaveLeaderboardGalleryItem";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
interface WaveLeaderboardGalleryProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly curatedByGroupId?: string | undefined;
}
export const WaveLeaderboardGallery: React.FC<WaveLeaderboardGalleryProps> = t0 => {
  const $ = _c(28);
  const {
    wave,
    sort,
    onDropClick,
    curatedByGroupId
  } = t0;
  let t1;
  if ($[0] !== curatedByGroupId || $[1] !== sort || $[2] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort,
      curatedByGroupId
    };
    $[0] = curatedByGroupId;
    $[1] = sort;
    $[2] = wave.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  const [animationKey, setAnimationKey] = React.useState(0);
  const [previousSort, setPreviousSort] = React.useState(sort);
  let t2;
  let t3;
  if ($[4] !== previousSort || $[5] !== sort) {
    t2 = () => {
      if (previousSort !== sort) {
        setPreviousSort(sort);
        setAnimationKey(_temp);
      }
    };
    t3 = [sort, previousSort];
    $[4] = previousSort;
    $[5] = sort;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  React.useEffect(t2, t3);
  let t4;
  if ($[8] !== drops) {
    t4 = drops.filter(_temp2) || [];
    $[8] = drops;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const dropsWithMedia = t4;
  if (isFetching && dropsWithMedia.length === 0) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-flex tw-h-32 tw-items-center tw-justify-center"><div className="tw-text-sm tw-text-iron-500">Loading drops...</div></div>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  if (dropsWithMedia.length === 0) {
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-flex tw-h-32 tw-items-center tw-justify-center tw-text-sm tw-text-iron-500">No drops to show</div>;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== animationKey || $[13] !== dropsWithMedia || $[14] !== onDropClick || $[15] !== sort) {
    let t6;
    if ($[17] !== animationKey || $[18] !== onDropClick || $[19] !== sort) {
      t6 = drop_0 => <WaveLeaderboardGalleryItem key={drop_0.id} drop={drop_0} onDropClick={onDropClick} activeSort={sort} animationKey={animationKey} />;
      $[17] = animationKey;
      $[18] = onDropClick;
      $[19] = sort;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t5 = dropsWithMedia.map(t6);
    $[12] = animationKey;
    $[13] = dropsWithMedia;
    $[14] = onDropClick;
    $[15] = sort;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[21] !== fetchNextPage || $[22] !== hasNextPage || $[23] !== isFetchingNextPage) {
    t6 = hasNextPage && <div className="tw-col-span-full tw-mb-2 tw-mt-4 tw-flex tw-justify-center"><button onClick={() => fetchNextPage()} disabled={isFetchingNextPage} className="tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-bg-iron-900 tw-px-4 tw-py-2 tw-text-sm tw-text-iron-400 tw-transition desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-300">{isFetchingNextPage ? "Loading more..." : "Load more drops"}</button></div>;
    $[21] = fetchNextPage;
    $[22] = hasNextPage;
    $[23] = isFetchingNextPage;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6) {
    t7 = <div className="tw-@container"><div className="tw-grid tw-gap-x-4 tw-gap-y-8 @lg:tw-grid-cols-2 @3xl:tw-grid-cols-3">{t5}{t6}</div></div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
};
function _temp(prev) {
  return prev + 1;
}
function _temp2(drop) {
  return (drop.parts[0]?.media.length ?? 0) > 0;
}